import type ReloaderService from '../../commons/services/reloader.service';
import type LoanService from '../../commons/services/loan.service';
import type ToasterService from '../../commons/services/toaster-service';
import type {LocalizationService} from '../../commons/providers/localization.provider';

export default class LoansController {

    /*@ngInject*/
    constructor(
        private toProcess: boolean,
        private loanService: LoanService,
        private toasterService: ToasterService,
        private localizationService: LocalizationService,
        private reloader: ReloaderService
    ) {
    }

    public async processLoan() {
        await this.loanService.processLoan();
        this.reloader.reload();
        this.toasterService.showSuccess(this.localizationService.get(/* @kp-localization loan.ProcessedOrder */ 'loan.ProcessedOrder'));
    }

}
